import { useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { api } from "@/lib/api";

interface P { open: boolean; onClose: () => void }

export function ForgotPasswordModal({ open, onClose }: P) {
  const [ident, setIdent] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [hint, setHint] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setMsg(null); setHint(null);
    try {
      const r = await api<{ delivered: boolean; hint: string | null }>(
        "/api/account/password/reset/request",
        { method: "POST", body: JSON.stringify({ identifier: ident }) },
      );
      setMsg("Si un compte avec cet email existe, un mail a été envoyé.");
      if (r.hint) setHint(r.hint);
    } catch (e2) {
      setMsg(e2 instanceof Error ? e2.message : "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="Mot de passe oublié">
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div className="muted" style={{ fontSize: 13 }}>
          Uniquement pour les comptes avec un email vérifié. Tape ton email ou ton nom d'utilisateur.
        </div>
        <input value={ident} onChange={(e) => setIdent(e.target.value)}
               placeholder="ton@email.com ou pseudo" required
               style={{ padding: 12, background: "var(--bg-elev-2)",
                        border: "1px solid var(--line)", borderRadius: 8, color: "var(--fg)" }} />
        {msg && <div style={{ color: "#4ade80", fontSize: 13 }}>{msg}</div>}
        {hint && <div style={{ color: "#fbbf24", fontSize: 12 }}>{hint}</div>}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button type="button" className="btn" onClick={onClose}>Fermer</button>
          <button type="submit" className="btn primary" disabled={busy || !ident}>
            {busy ? "…" : "Envoyer le lien"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
